import React from 'react';
import './styles.scss';

class About extends React.Component {
	render() {
		return (
		<main id="about" className="main about">
			<h1>Nosotros</h1>
		</main>
		)
	}
};

export default About;